import * as React from 'react';

type Props = {
    id: string;
    className?: string;
    children?: React.ReactNode;
};

export function Placeholder(props: Props) {
    const {
        id,
        className = 'ads__unit ads__unit--banner ads__unit--fullwidth',
        children,
    } = props;

    return (
        <div id={id} className={className}>
            {children}
        </div>
    );
}
